<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">

    <mat-form-field class="w20 m-r-15 m-b-0" floatLabel="always">
        <mat-label>Código</mat-label>
        <input [formControl]="searchCode" matInput placeholder="Código" (click)="OnsearchCodeClick()" class="searchBar"
            autocomplete="off">
    </mat-form-field>

    <mat-form-field class="w77 m-b-0" floatLabel="always">
        <mat-label>Descripción</mat-label>
        <input [formControl]="searchDescription" matInput placeholder="Descripción" (click)="OnsearchDescClick()"
            class="searchBar" autocomplete="off">
    </mat-form-field>

</div>



<ul class="diagnosis-breadcrumb m-b-15 overflow-hidden" fxlayout="row" *ngIf="selectionStack.length>0">
    <li id="diagnosis-breadcrumb-position" *ngFor="let item of selectionStack;let i = index"
        (click)="OnStackItemClick(i)">
        <mat-icon class="s-16 mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true" *ngIf="i>0">
            chevron_right
        </mat-icon>
        <span>{{item.descripcion}}</span>
    </li>
</ul>

<div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start"
    [ngClass]="(IsLoading)?loadSpinnerClass:''">
    <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
        <div class="spinner-tree" *ngIf="IsLoading == true">
            <mat-progress-spinner class="m-auto spinner-loader" [diameter]="50" color="primary" mode="indeterminate">
            </mat-progress-spinner>
        </div>
    </div>
</div>

<div class="diagnosis-table">
    <table id="th-none" mat-table class="simple clickable" [dataSource]="(TableData)">
        <caption></caption>
        <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef class="d-none"> </th>
            <td mat-cell *matCellDef="let column"> {{column.code}} </td>
        </ng-container>

        <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef class="d-none"></th>
            <td mat-cell *matCellDef="let column"> {{column.descripcion}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="TableColumns;"></tr>
        <tr [class.selected]="AllowConfirm === true && row.Id === DiagnosisId" mat-row
            *matRowDef="let row; columns: TableColumns;" (click)="Onclick(row)"></tr>
    </table>
</div>

<div class="text-a-r p-t-15">
    <button mat-raised-button color="accent" class="m-r-15" (click)="ConfirmCodes()"
        [disabled]=!AllowConfirm>Confirmar</button>
    <button mat-raised-button color="warn" (click)="Cancel()">Cancelar</button>
</div>